import React, { useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useSelector, useDispatch } from 'react-redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import SharedScript from '@americanexpress/shared-scripts';
import { compose } from 'redux';
import childRoutes from '../childRoutes';
import { reducer } from '../ducks';

const CommunicationsRoot = ({ languageData, children }) => {
  const dispatch = useDispatch();
  const locale = useSelector((state) => state.getIn(['intl', 'activeLocale']));
  useEffect(() => {
    dispatch(loadLanguagePack('axp-doc-communications-root', { fallbackLocale: 'en-US' }));
  }, [locale, dispatch]);
  return (
    <IntlProvider locale={locale} messages={languageData}>
      <Helmet
        link={[
          {
            rel: 'stylesheet', // TODO: we should generate the below line to use the same version of dls as was installed
            href: 'https://www.aexp-static.com/cdaas/one/statics/@americanexpress/dls/6.21.5/package/dist/6.21.5/styles/dls.min.css',
          },
          { rel: 'icon', href: 'https://www.americanexpress.com/favicon.ico' },
        ]}
        title={languageData.pageTitle}
      >
        <body className="dls-gray-02-bg" />
      </Helmet>
      <SharedScript
        id="one-identity-script"
        name="one-identity-session"
        version="^1.0.0"
        windowCheck="AmexSession"
      />
      {children}
    </IntlProvider>
  );
};
export const TestableCommunicationsRoot = CommunicationsRoot;
CommunicationsRoot.childRoutes = childRoutes;

const loadModuleData = async ({ store }) => {
  const { dispatch } = store;
  await dispatch(
    loadLanguagePack('axp-doc-communications-root', { fallbackLocale: 'en-US' })
  );
};

CommunicationsRoot.holocron = {
  name: 'axp-doc-communications-root',
  loadModuleData,
  reducer,
};

CommunicationsRoot.propTypes = {
  languageData: PropTypes.shape({
    pageTitle: PropTypes.string.isRequired,
  }).isRequired,
  children: PropTypes.node,
};

/* istanbul ignore next */
if (!global.BROWSER) {
  // eslint-disable-next-line n/global-require -- we only want to require this in the server context
  CommunicationsRoot.appConfig = require('../appConfig').default;
}

const hocChain = compose(oneAppModuleWrapper('axp-doc-communications-root'));

export { CommunicationsRoot as ComponentUnderTest, loadModuleData };
export default hocChain(CommunicationsRoot);
